<template>
  <div>
    <div class="package-detail bg-white flex mdmax:flex-col shadow-border-b">
      <div class="p-6 flex-1 shadow-border-r mdmax:shadow-border-b">
        <p class="font-bold text-lg mb-6">Rincian Layanan</p>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">ID</label>
          <p class="text-neutral-500">{{ packageDetail.id }}</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama Layanan/Paket Layanan</label>
          <p class="text-neutral-500">{{ packageDetail.name }}</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kode Layanan (Sistem saat ini)</label>
          <p class="text-neutral-500">{{ packageDetail.package_external_code || '-' }}</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Deskripsi</label>
          <p class="text-neutral-500" v-html="packageDetail.description"></p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tipe Layanan</label>
          <p class="text-neutral-500">
            {{ getDeliveryType(packageDetail.delivery_service_type) }}
          </p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Cost Mapping</label>
          <p class="text-neutral-500">{{ packageDetail.cost_mapping_name }}</p>
        </div>
        <div class="">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Syarat & Ketentuan</label>
          <p class="text-neutral-500 tnc" v-html="packageDetail.tnc"></p>
        </div>
        <!-- <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Provinsi</label>
        <p class="text-neutral-500">
          -
        </p>
      </div>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kelurahan</label>
        <p class="text-neutral-500">
          -
        </p>
      </div>
      <div class="">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kecamatan</label>
        <p class="text-neutral-500">
          -
        </p>
      </div> -->
      </div>
      <div class="p-6 flex-1 mdmax:flex-auto mdmax:w-full">
        <p class="font-bold text-lg mb-6">Status Kategori</p>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Status</label>
          <p class="text-neutral-500">{{ packageDetail.status | capitalize }}</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kategori</label>
          <ul class="list-disc pl-5">
            <li class="text-neutral-500" v-for="(category, index) in packageDetail.package_goods_categories" :key="'category-' + index">
              {{ category.category_name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="package-detail p-6  bg-white flex gap-4 justify-end items-center mdmax:flex-col">
      <Button buttonText="Hapus" type="delete" @action="toggleDeleteConfirmation" />
      <LinkButton buttonText="Edit" type="secondary" linkType="internal" :url="`/package/update/${packageId}`" />
    </div>
    <Modal :modalVisible="visibleDeleteConfirmation" @close="toggleDeleteConfirmation()" width="600px" id="delete-confirmation-modal">
      <template slot="modal-content">
        <div class="flex items-center justify-start gap-6 mb-6">
          <span class="flex-shrink-0"><Alert color="neutral-700"/></span>
          <div class="flex-col flex gap-2 items-start">
            <p class="text-2xl font-bold">Hapus Layanan?</p>
            <p class="text-sm text-neutral-500 text-left">
              Apakah Anda yakin untuk menghapus layanan ini?
            </p>
          </div>
        </div>
        <div class="flex justify-end gap-6">
          <Button buttonText="Tidak" type="secondary" @action="toggleDeleteConfirmation()" :size="isMobile ? 'full' : 'regular'" />
          <Button buttonText="Ya" type="primary" @action="confirmDelete()" :size="isMobile ? 'full' : 'regular'" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { capitalize } from '@/util'
export default {
  components: {
    Button: () => import(/* webpackChunkName: "Button" */ '@/components/Forms/Button'),
    LinkButton: () => import(/* webpackChunkName: "LinkButton" */ '@/components/Forms/LinkButton'),
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal'),
    Alert: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Alert')
  },
  filters: { capitalize },
  data() {
    return {
      deliveryServiceTypeList: [
        {
          name: 'Pickup and Dropoff',
          value: 'A'
        },
        {
          name: 'Pickup Only',
          value: 'P'
        },
        {
          name: 'Dropoff Only',
          value: 'D'
        }
      ],
      visibleDeleteConfirmation: false
    }
  },
  computed: {
    ...mapGetters('partner', ['packageDetail']),
    ...mapGetters('auth', ['userData']),
    ...mapGetters('common', ['isMobile']),
    packageId() {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions('partner', ['getPackageDetail', 'removePackage']),
    ...mapActions('common', ['setToast', 'showLoading', 'hideLoading']),
    toggleDeleteConfirmation() {
      this.visibleDeleteConfirmation = !this.visibleDeleteConfirmation
    },
    confirmDelete() {
      this.showLoading()
      const partnerId = this.userData?.user?.group_id
      this.removePackage({
        partnerId: partnerId,
        packageId: this.packageId
      }).then(() => {
        let self = this
        this.hideLoading()
        this.toggleDeleteConfirmation()
        this.setToast({
          options: {
            type: 'success',
            duration: 1000,
            primaryText: 'Berhasil Menghapus Layanan',
            secondaryText: 'Data telah kami simpan',
            callback: () => {
              self.$router.push('/package')
            }
          }
        })
      })
    },
    getPackageInfo() {
      this.showLoading()
      const partnerId = this.userData?.user?.group_id
      this.getPackageDetail({
        partnerId: partnerId,
        packageId: this.packageId
      }).then(this.hideLoading())
    },
    getDeliveryType(type) {
      const result = this.deliveryServiceTypeList.filter(item => item.value === type)[0]
      return result && result.name
    }
  },
  created() {
    this.getPackageInfo()
  }
}
</script>
<style lang="scss" scoped>
.tnc {
  &::v-deep ul {
    list-style: disc;
    padding-left: 16px;
  }
  &::v-deep ol {
    list-style: decimal;
    padding-left: 16px;
  }
}
</style>
